export default {
	getCategoryIds: function(categories) {
		let options = [];
		for(var i = 0; i < categories.length; i++) {
			options.push(categories[i].id);
		}
		return options;
	},
	getCategoryOptions: function(categories) {
		let options = [];
		for(var i = 0; i < categories.length; i++) {
			options.push({
				name : categories[i].name,
				id : categories[i].id,
			});
		}
		return options.sort(this.sortArray);
	},
	sortArray: function(a, b) {
		// Use toUpperCase() to ignore character casing
		const catA = a.name.toUpperCase();
		const catB = b.name.toUpperCase();

		let comparison = 0;
		if (catA > catB) {
			comparison = 1;
		} else if (catA < catB) {
			comparison = -1;
		}
		return comparison;
	},
	pluckArray: function(array, field) {
		let options = [];
		for(var i = 0; i < array.length; i++) {
			options.push(array[i][field]);
		}
		return options;
	},
	getSubCategories: function(categories, selectedCategories) {
		let options = [];
		for(var i = 0; i < selectedCategories.length; i++) {
			for(var j = 0; j < categories.length; j++) {
				if( categories[j].id === selectedCategories[i].id ) {
					options.push({
						group : categories[j].name,
						groupid : categories[j].id,
						subcategories :  this.getCategoryOptions(categories[j].subcategories),
					});
				}
			}
		}
		return options;
	},
	getCategoryIdsFormated: function(categories) {
		if(categories.length < 1)
			return "";

		let options = "";
		for(var i = 0; i < categories.length; i++) {
			if(i > 0) {
				options += ",";
			}
			options += '"'+ categories[i].id +'"';
		}
		return '{' + options + '}';
	},
	getCategoryNamesByIds: function(categories, ids) {
		if(categories.length < 1 || ids.length < 1)
			return [];

		let options = [];
		for(var i = 0; i < categories.length; i++) {
			for(var j = 0; j < ids.length; j++) {
				if(categories[i].id == ids[j]) {
					options.push({
						id: categories[i].id,
						name: categories[i].name
					});
				}
			}
		}
		return options;
	},
}
